// external imports
import React from 'react';
import PropTypes from 'prop-types';

class FileInput extends React.Component {
  _handleUpload = evt => {
    const { onChange } = this.props;
    const file = evt.target.files[0];
    onChange(file);

    // free up the fileInput again
    this.fileInput.value = null;
  };

  render() {
    const {
      acceptedTypes,
      style,
      children,
      inputId,
      className,
      t,
    } = this.props;
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div style={style} className={className}>
        <label htmlFor={inputId || 'file-input'} style={{ display: 'none' }}>
          {t(
            'FilePicker.FileInput.LabelText',
            'Upload File',
            'The label for the file upload input that users use to upload files'
          )}
        </label>
        <input
          accept={acceptedTypes.join(',')}
          type="file"
          style={{ display: 'none' }}
          id={inputId || 'file-input'}
          name={inputId || 'file-input'}
          onChange={this._handleUpload}
          ref={ele => (this.fileInput = ele)}
        />
        {React.cloneElement(children, {
          onClick: () => {
            if (children && children.props.onClick) children.props.onClick();
            this.fileInput.click();
          },
        })}
      </div>
    );
  }
}

FileInput.defaultProps = {
  acceptedTypes: ['*'],
};

FileInput.propTypes = {
  style: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
  acceptedTypes: PropTypes.arrayOf(PropTypes.string),
  inputId: PropTypes.string,
};

export default FileInput;
